export default __webpack_public_path__ + "static/media/info.603cf7a6.svg";